import { Button } from '@/shared/ui'
import { Text, Title } from '@/shared/ui/Typography'

import styles from './catalog-empty.module.scss'

type EmptyCatalogProps = {
	onReset?: () => void
}

export const EmptyCatalog = (props: EmptyCatalogProps) => {
	const { onReset } = props
	return (
		<section className={styles.emptyCatalog}>
			{/* <Icon iconId={emptyIcon} /> */}
			<Title level="1" bottomOffset="2x">
				Нет подходящих товаров
			</Title>
			<Text style={{ marginBottom: '32px' }}>Попробуйте смягчить условия поиска или поискать в другой категории</Text>

			<br />
			<br />
			<Button onClick={() => onReset?.()}>Сбросить фильтр</Button>
		</section>
	)
}
